var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05246 6.0009L6.55027 1.46527C6.88317 1.12914 6.88317 0.587019 6.55027 0.250891C6.39164 0.0903187 6.17527 9.26364e-07 5.9496 9.165e-07C5.72393 9.06636e-07 5.50756 0.0903186 5.34893 0.250891L0.250468 5.39281C-0.0834934 5.72857 -0.0834935 6.27143 0.250468 6.60719L5.34872 11.7491C5.50756 11.9097 5.72393 12 5.9496 12C6.17527 12 6.39164 11.9097 6.55048 11.7491C6.88317 11.4129 6.88317 10.8708 6.55005 10.5347L2.05246 6.0009Z",
    fill: "#001EBE",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/arrow-left-blue.5e755987557dd426a879b5d18f1e0523.svg";
export { ForwardRef as ReactComponent };